exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-block[data-v-69ab7fed] {\n    padding: 0px 0px 0px 0px;\n    margin: auto;\n    width: 100%\n}\n/*\nul {\n  padding-left: initial;\n}*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69ab7fed","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/contacts/CMEditContact.vue
// module id = 1572
// module chunks = 2